import React from "react";
import AuthGuard from "./AuthGuard";

const CreateAudiencePixels = React.lazy(() =>
  import("../pages/AudiencePixels/CreateAudiencePixels")
);
const AudiencePixels = React.lazy(() =>
  import("../pages/AudiencePixels/AudiencePixels")
);

const AudiencePixelRoutes = [
  {
    path: "advertiser/createaudiencepixels",
    element: (
      <AuthGuard>
        <CreateAudiencePixels />
      </AuthGuard>
    ),
  },
  {
    path: "advertiser/editaudiencepixels/:id",
    element: (
      <AuthGuard>
        <CreateAudiencePixels />
      </AuthGuard>
    ),
  },
  {
    path: "advertiser/audiencepixels",
    element: (
      <AuthGuard>
        <AudiencePixels />
      </AuthGuard>
    ),
  },
];

export default AudiencePixelRoutes;
